import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-base-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class BaseStatusComponent {
  @Input() statusLabel!: string;
  @Input() className?: string;

  constructor() {}
}
